<div [formGroup]="formGroup" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field [appearance]="appearance" class="fuse-mat-dense flex-auto">
    @if (label) {
      <mat-label>{{ t(label) | capitalize }}</mat-label>
    }
    <input
      matInput
      autocomplete="off"
      [placeholder]="placeholder"
      [name]="controlName"
      [formControlName]="controlName"
      [type]="visible ? 'text' : 'password'"
      [autocomplete]="autocomplete"
      [maxlength]="maxLength"
    />
    <mat-icon matSuffix (click)="visible = !visible" class="cursor-pointer">
      {{ visible ? 'visibility' : 'visibility_off' }}
    </mat-icon>
    @if (validateField.hasErrorValidate(formControl, 'required')) {
      <mat-error>{{ t('required-field') }}</mat-error>
    }
    @if (validateField.hasErrorValidate(formControl, 'minlength')) {
      <mat-error>
        {{ t('minimum') | titlecase }}
        {{ validateField.validateLength(formControl, 'minlength') }}
        {{ t('characters') }}
      </mat-error>
    }
    @if (validateField.hasErrorValidate(formControl, 'maxlength')) {
      <mat-error>
        {{ t('maximum') | titlecase }}
        {{ validateField.validateLength(formControl, 'maxlength') }}
        {{ t('characters') }}
      </mat-error>
    }
    @if (
      validateField.hasErrorValidate(formControl, 'equalsTo') &&
      !validateField.hasErrorValidate(formControl, 'minlength') &&
      !validateField.hasErrorValidate(formControl, 'maxlength') &&
      !validateField.hasErrorValidate(formControl, 'required')
    ) {
      <mat-error>{{ t('error-equals-password') }}</mat-error>
    }
    @if (
      validateField.hasErrorValidate(formControl, 'notEqualsTo') &&
      !validateField.hasErrorValidate(formControl, 'equalsTo') &&
      !validateField.hasErrorValidate(formControl, 'minlength') &&
      !validateField.hasErrorValidate(formControl, 'maxlength') &&
      !validateField.hasErrorValidate(formControl, 'required')
    ) {
      <mat-error>{{ t('error-new-password-equals') }}</mat-error>
    }
    @if (
      validateField.hasErrorValidate(formControl, 'containsLettersAndNumbers') &&
      !validateField.hasErrorValidate(formControl, 'equalsTo') &&
      !validateField.hasErrorValidate(formControl, 'notEqualsTo') &&
      !validateField.hasErrorValidate(formControl, 'minlength') &&
      !validateField.hasErrorValidate(formControl, 'maxlength') &&
      !validateField.hasErrorValidate(formControl, 'required')
    ) {
      <mat-error>
        {{ t('error-not-contains-letters-and-numbers') }}
      </mat-error>
    }
  </mat-form-field>
</div>
